import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { getStaticContent } from "../i18n/staticPages";

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const sc = getStaticContent();
  const c = sc.faq;

  const toggleQuestion = (categoryIndex, questionIndex) => {
    const key = `${categoryIndex}-${questionIndex}`;
    setOpenIndex(openIndex === key ? null : key);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <header className="bg-slate-900/80 backdrop-blur-sm border-b border-slate-700 sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="/nkt-bee-logo.png" alt="NKT Logo" className="w-8 h-8 object-contain" />
            <span className="text-xl font-bold text-white">NKT - Teklif Hazırla</span>
          </Link>
          <Link to="/">
            <Button variant="outline" className="border-amber-500 text-amber-400 hover:bg-amber-500/10">
              {sc.common.home}
            </Button>
          </Link>
        </div>
      </header>

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-white mb-4">{c.title}</h1>
            <p className="text-slate-400 text-lg">{c.subtitle}</p>
          </div>

          <div className="space-y-8">
            {c.cats.map((category, categoryIndex) => (
              <Card key={categoryIndex} className="bg-slate-800/50 border-slate-700">
                <CardHeader>
                  <CardTitle className="text-amber-400 flex items-center gap-2">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    {category.c}
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-2">
                  {category.qs.map((item, questionIndex) => {
                    const key = `${categoryIndex}-${questionIndex}`;
                    const isOpen = openIndex === key;
                    return (
                      <div key={questionIndex} className="border border-slate-700 rounded-lg overflow-hidden">
                        <button
                          onClick={() => toggleQuestion(categoryIndex, questionIndex)}
                          className="w-full px-4 py-3 flex items-center justify-between text-left bg-slate-700/30 hover:bg-slate-700/50 transition"
                          data-testid={`faq-question-${categoryIndex}-${questionIndex}`}
                        >
                          <span className="text-white font-medium pr-4">{item.q}</span>
                          <svg
                            className={`w-5 h-5 text-amber-400 flex-shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                            fill="none" stroke="currentColor" viewBox="0 0 24 24"
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        </button>
                        {isOpen && (
                          <div className="px-4 py-3 bg-slate-800/50">
                            <p className="text-slate-300 leading-relaxed">{item.a}</p>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </CardContent>
              </Card>
            ))}
          </div>

          <Card className="mt-12 bg-gradient-to-r from-amber-500/20 to-orange-500/20 border-amber-500/30">
            <CardContent className="py-8 text-center">
              <h3 className="text-2xl font-bold text-white mb-4">{c.stillTitle}</h3>
              <p className="text-slate-300 mb-6">{c.stillDesc}</p>
              <Link to="/contact">
                <Button className="bg-amber-600 hover:bg-amber-700">{sc.common.contactBtn}</Button>
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
